
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(11(1|60)|3669|6561|7453)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
